import { FloatingToolBarController } from './floating-tool-bar.controller.js'

function floatingToolBar () {
  return {
    restrict: 'E',
    scope: {
      selectedAssets: '=',
      selectedFolders: '=',
      currentPage: '<',
      sections: '<',
      pricing: '<'
    },
    templateUrl: '/repository/directives/floating-tool-bar/floating-tool-bar-directive.html?$$REVISION$$',
    controller: FloatingToolBarController
  }
}

export { floatingToolBar }
